<template>
  <div style="padding: 20px;background-color: #ffffff;">
    <div class="">
      <div @keyup.enter.stop="getPage({pageNum: 1})">
        <el-select v-model="queryParam.batchId" placeholder="选择考试" @change="getPage({pageNum: 1})" filterable style="width: 200px;margin-right:10px;">
          <el-option v-for="(item,index) in batchList" :key="index" :label="item.batchName" :value="item.batchId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-button @click="getPage({pageNum: 1})" type="primary">搜索</el-button>
        <el-button @click="edit(queryParam.batchId)" type="primary">新增考场</el-button>
      </div>
      <div class="text-right" style="margin-top: 10px;">
      </div>
    </div>
    <div ref="page" style="margin-top: 12px;">
      <el-table :data="page.list" stripe :height="tableHeight" size="medium" :span-method="objectSpanMethod">
        <el-table-column prop="id" label="序号">
          <template slot-scope="scope">
            {{1+page.pageSize*(page.pageNum-1)+scope.$index}}
          </template>
        </el-table-column>
        <el-table-column prop="roomName" label="考场名称"></el-table-column>
        <el-table-column prop="specialtyNames" label="包含专业"></el-table-column>
        <el-table-column prop="mainTeacherNames" label="主评官"></el-table-column>
        <el-table-column prop="unevaluateNum" label="待评分人数"></el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button size="mini" type="text"
                       @click="$router.push({path:'./exam',query:{batchId:scope.row.batchId,roomId:scope.row.roomId,specialtyId:scope.row.specialtyId,isOnline:scope.row.isOnline}})">
              查看考生信息列表
            </el-button>
            <el-button size="mini" type="text" @click="edit(queryParam.batchId, true, scope.row.roomId)">
              编辑
            </el-button>
            <el-button style="color: red" size="mini" type="text" @click="del(scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="false" style="margin-top: 20px;">
        <el-pagination class="text-center" background
                       :page-sizes="[20, 50, 100, 200]" layout="total, sizes, prev, pager, next, jumper"
                       :total="page.total" :page-size="page.pageSize" :current-page="page.pageNum"
                       @current-change="getPage({pageNum:$event})" @size-change="getPage({pageNum:1,pageSize:$event})"></el-pagination>
      </div>
    </div>
    <el-dialog :title="editForm.title" v-if="editForm.show" :visible.sync="editForm.show" width="900px"
               :close-on-press-escape="false" :close-on-click-modal="false" :destroy-on-close="true">
      <Edit :row="editForm.row" :editType="editType" :room="editForm.room" @close="closeDialog" style="max-height: 500px;overflow-y: auto;"></Edit>
    </el-dialog>
  </div>
</template>
<script>
import Edit from './newroom-edit'

export default {
  name: 'list',
  components: { Edit },
  props: [],
  data () {
    return {
      tableHeight: 200,
      queryParam: { batchId: this.$route.query.batchId },
      page: { pageSize: 20, pageNum: 1 },
      editForm: { show: false, row: null, title: '设置考场' },
      batchList: [],
      spanArr: [],
      pos: 0,
      editType: false
    }
  },
  async created () {
    this.batchList = await this.$HTTP.ApiBatch.getList({ batchStatus: [2, 3] })
    if (this.Tool.isNull(this.batchList)) {
      throw new Error('请先添加考试数据')
    }
    if (!this.queryParam.batchId) {
      this.queryParam.batchId = this.$route.query.batchId
    }
    if (!this.$route.query.batchId) {
      this.queryParam.batchId = this.batchList[0].batchId
    }
    await this.getPage()
  },
  async mounted () {
    this.Tool.windowResizeEvent(() => {
      this.tableHeight = this.Tool.calcTableHeight(this.$refs['page'])
    })
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async getPage (queryParam) {
      try {
        this.editForm.show = false
        this.editForm.row = null
        this.queryParam = Object.assign({}, this.queryParam, queryParam)
        let list = await this.$HTTP.GradeRoom.getList(this.queryParam)
        this.page = { list: list || [], pageNum: 1, pageSize: 10000, total: 10000, totalPage: 1 }
        this.getSpanArr(this.page.list, 'roomId')
        this.$nextTick(() => {
          let wrapper = window.document.getElementsByClassName('el-table__body-wrapper')
          if (wrapper) {
            wrapper[0].scrollTop = 0
          }
        })
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async edit (row, type, room) {
      if (type) {
        this.editType = true
      } else {
        this.editType = false
      }
      if (row) {
        this.editForm.row = row
      } else {
        this.editForm.row = null
      }
      if (room) {
        this.editForm.room = room
      } else {
        this.editForm.room = null
      }
      this.editForm.show = true
    },
    closeDialog () {
      this.editForm.show = false
      this.getPage()
    },
    getSpanArr (list, keyCol) {
      this.spanArr = []
      for (let i = 0; i < list.length; i++) {
        if (i === 0) {
          this.spanArr.push(1)
          this.pos = 0
        } else {
          if (list[i][keyCol] === list[i - 1][keyCol]) {
            this.spanArr[this.pos] += 1
            this.spanArr.push(0)
          } else {
            this.spanArr.push(1)
            this.pos = i
          }
        }
      }
    },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if ([0, 1, 5, 6].includes(columnIndex)) {
        const _row = this.spanArr[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col
        }
      }
    },
    async del (row) {
      try {
        let confirm = await this.$confirm('确定要删除该考场吗？', '提示', { type: 'warning' })
        if (confirm === 'confirm') {
          await this.$HTTP.GradeRoom.del(row.roomId)
          await this.getPage()
        }
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async update (room) {

    }
  }
}
</script>
